import { render, staticRenderFns } from "./ChartTarifsAbonents.vue?vue&type=template&id=0288a3fe&"
import script from "./ChartTarifsAbonents.vue?vue&type=script&lang=js&"
export * from "./ChartTarifsAbonents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports